const reports = {
  ANF: {
    "1": {
      code: "Annen spesielt hensynskrevende art",
      initial_value: "1",
      description:
        "art som det er knyttet spesielle forvaltningsmessige problemstillinger til. ",
      name_english: "",
      description_english: "",
      name: "Annen spesielt hensynskrevende art"
    },
    "2": {
      code: "Ansvarsart",
      initial_value: "2",
      description:
        "arter der man finner mer enn 25 % av europeisk bestand i Norge. flere av disse artene er relativt vanlige i Norge.",
      name_english: "",
      description_english: "",
      name: "Ansvarsart"
    },
    "3": {
      code: "Fredet art",
      initial_value: "3",
      description: "art som er fredet ved Kongelig resolusjon",
      name_english: "",
      description_english: "",
      name: "Fredet art"
    },
    "4": {
      code: "Fremmed art",
      initial_value: "4",
      description:
        "arter som er fremmed for Norge og med høy eller svært høy økologisk risiko, samt arter som er internt spredd i Norge med høy økologisk risiko, ihht svartelister",
      name_english: "",
      description_english: "",
      name: "Fremmed art"
    },
    "5": {
      code: "Nær trua art",
      initial_value: "5",
      description:
        "art i som er plassert i kategorien NT-nær truet i gjeldende norsk rødliste",
      name_english: "",
      description_english: "",
      name: "Nær trua art"
    },
    "6": {
      code: "Prioritert art",
      initial_value: "6",
      description:
        "art som har status som prioritert art ihht naturmangfolddloven",
      name_english: "",
      description_english: "",
      name: "Prioritert art"
    },
    "7": {
      code: "Spesiell økologisk form",
      initial_value: "7",
      description:
        "angir økologisk form av en art som må ivaretas særskilt. f.eks. namdalsbleke i Namsen",
      name_english: "",
      description_english: "",
      name: "Spesiell økologisk form"
    },
    "8": {
      code: "Trua art",
      initial_value: "8",
      description:
        "art som er plassert i en av følgende kategorier i gjeldende norsk rødliste: CR-kritisk truet, EN-truet, VU-sårbar",
      name_english: "",
      description_english: "",
      name: "Trua art"
    }
  },
  N13: {
    D23: {
      code: "andreViktigeKulturmarkstyper",
      initial_value: "D23",
      description: "",
      name_english: "",
      description_english: "",
      name: "Andre viktige kulturmarkstyper"
    },
    D21: {
      code: "annenKulturmarkseng",
      initial_value: "D21",
      description: "",
      name_english: "",
      description_english: "",
      name: "Annen kulturmarkseng"
    },
    H00: {
      code: "annenViktigForekomst",
      initial_value: "H00",
      description: "",
      name_english: "",
      description_english: "",
      name: "Annen viktig forekomst"
    },
    C02: {
      code: "arktisk-alpinGrunnVåtmark",
      initial_value: "C02",
      description:
        "Utformingene C0101 rabbe og C0102 leside er flyttet til ny naturtype C03 rik fjellhei og tundra. Utforming C0103 Snøleie er flyttet til ny naturtype C04 Rike snøleier.",
      name_english: "",
      description_english: "",
      name: "Arktisk-alpin grunn våtmark"
    },
    D03: {
      code: "artsrikVeikant",
      initial_value: "D03",
      description:
        "Urterike veikanter med etablert vegetasjonsdekke. Vegkanter kan utvise et stort artsmangfold og blomsterprakt og består ofte av en blanding av arter fra flere vegetasjonstyper. Artssammensetningen kan være lik den vi finner i slåtte­marker og veikanter vil i noen tilfeller kunne tjene som erstatningsbiotop for slåttemarker. I tidligere tider var veikantslått en selvfølgelig del av fôrberginga, men i dag slås veikanten hovedsakelig for å bedre sikten langs veien. Lokaliteter med høyt innslag av slåttemarksarter og generelt stabile, artsrike biotoper bør prioriteres ved registrering. ",
      name_english: "",
      description_english: "",
      name: "Artsrik veikant"
    },
    D06: {
      code: "beiteskog",
      initial_value: "D06",
      description: "Skog som beites og som har et tydelig beitepreg.",
      name_english: "",
      description_english: "",
      name: "Beiteskog"
    },
    D22: {
      code: "borealHei",
      initial_value: "D22",
      description: "",
      name_english: "",
      description_english: "",
      name: "Boreal hei"
    },
    G07: {
      code: "brakkvannsdelta",
      initial_value: "G07",
      description:
        'Et prosjekt for å reklassifisere "Brakkvannsdelta" til "Aktivt marint delta" ble aldri fullført i naturbase. Navnet "brakkvannsdelta" ble reintrodusert pr 01.01.2020',
      name_english: "",
      description_english: "",
      name: "Brakkvannsdelta"
    },
    G08: {
      code: "brakkvannspoll",
      initial_value: "G08",
      description: "",
      name_english: "",
      description_english: "",
      name: "Brakkvannspoll"
    },
    E18: {
      code: "brakkvannssjø",
      initial_value: "E18",
      description: "Data overført fra G0203 i HB19 (10.01.2020)",
      name_english: "",
      description_english: "",
      name: "Brakkvannssjø"
    },
    F10: {
      code: "brannfelt",
      initial_value: "F10",
      description:
        "Skogbrann er en naturlig økologisk faktor. Suksesjonen etter brann er avhengig av vegetasjonen før brann og vegetasjon rundt som forsyner brann­feltet med frø. På rikere mark får en kraftig lauvtredominans av treslag som bjørk, osp og selje. På fattigere mark kommer furu tidlig inn, og det blir mindre innslag av lauv. Skogbrann frigjør en rekke næringsstoffer som fører til oppblomstring av pionerarter som geitrams og bringebær. De første årene etter en skogbrann er det et yrende insekt- og fugleliv på brannflata. ",
      name_english: "",
      description_english: "",
      name: "Brannfelt"
    },
    B11: {
      code: "breforland",
      initial_value: "B11",
      description: "",
      name_english: "",
      description_english: "",
      name: "Breforland"
    },
    E09: {
      code: "dam",
      initial_value: "E09",
      description:
        "Små og grunne vannansamlinger, hovedsakelig i kulturlandskapet. Naturlige eller oppdemte. Vanligvis under 50 x 50 m, uten bølgeslagserosjon langs bredden og med såpass liten dybde at rotfast vegetasjon kan dekke hele bunnen. Uttørking eller bunnfrysing kan ved ekstreme forhold finne sted.   De aller fleste ikke-kulturpåvirkete dammene (bortsett fra på elvesletter – se flomdammer og saltpåvirkete dammer/fjærepytter i strandsonen) vil være myrpregete. Slike myrdammer er svært vanlige, og det foreligger i dag ikke habitat­kunnskap til å skille ut særlig artsrike utforminger fra de mer trivi­elle. Lokaliteter med kjent forekomst av spesielle arter, særlig myrdammer med salamander eller rødlistede øyenstikker-arter kan også registreres som artsforekomster.",
      name_english: "",
      description_english: "",
      name: "Dam"
    },
    E01: {
      code: "deltaområde",
      initial_value: "E01",
      description:
        'Omfatter innlandsdeltaer, dvs. våtmarker og gruntområder i tilknytning til større elvemunninger, og med særlig vekt på intakte utforminger. Deltaplattformen omfatter landtunger (sedimentasjonsbanker), bakevjer, dammer, flomløp og langgrunne mudderflater. Kartleggingsobjektet er egentlig et landskapselement som inkluderer flere verdifulle naturtyper som også er omhandlet separat (kroksjøer/flomdammer, mudderbanker, fuktenger, riker­e sumpskog, større elveører, samt evjer, bukter og viker). Deltaområder er likevel valgt som en kartleggingsenhet fordi de utgjør helhetlige områder i landskapsøkologisk og forvaltningsmessig perspektiv Et prosjekt for å reklassifisere "Deltaområde" til "Aktivt ferskvannsdelta" ble aldri fullført i naturbase. Navnet "detlaområde" ble reintrodusert pr 01.01.2020',
      name_english: "",
      description_english: "",
      name: "Deltaområde"
    },
    G06: {
      code: "driftvoll",
      initial_value: "G06",
      description: "",
      name_english: "",
      description_english: "",
      name: "Driftvoll"
    },
    B12: {
      code: "dødisgrop",
      initial_value: "B12",
      description: "",
      name_english: "",
      description_english: "",
      name: "Dødisgrop"
    },
    E22: {
      code: "elveslette",
      initial_value: "E22",
      description: "",
      name_english: "",
      description_english: "",
      name: "Elveslette"
    },
    D51: {
      code: "engpregeteErstatningsbiotoper",
      initial_value: "D51",
      description: "",
      name_english: "",
      description_english: "",
      name: "Engpregete erstatningsbiotoper"
    },
    D14: {
      code: "erstatningsbiotoper",
      initial_value: "D14",
      description:
        "Samlebetegnelse på menneskepåvirkete eller menneske­skapte biotoper som erstatter/supplerer andre eller  tidligere leveområder, både kultur­påvirkete og ikke kulturpåvirkete, (særlig) for utsatte og sjeldne arter. Naturtypen har flere likhetstrekk med naturtypen skrotemark, men på skrotemark består floraelementet gjerne av innførte arter. ",
      name_english: "",
      description_english: "",
      name: "Erstatningsbiotoper"
    },
    D52: {
      code: "erstatningsbiotoperPåBergOgÅpenJord",
      initial_value: "D52",
      description: "",
      name_english: "",
      description_english: "",
      name: "Erstatningsbiotoper på berg og åpen jord"
    },
    D13: {
      code: "erstatningsbiotoperPåTresattMark",
      initial_value: "D13",
      description: "",
      name_english: "",
      description_english: "",
      name: "Erstatningsbiotoper på tresatt mark"
    },
    D53: {
      code: "erstatningsbiotoperPåVed",
      initial_value: "D53",
      description: "",
      name_english: "",
      description_english: "",
      name: "Erstatningsbiotoper på ved"
    },
    F21: {
      code: "flommarksskog",
      initial_value: "F21",
      description: "",
      name_english: "",
      description_english: "",
      name: "Flommarksskog"
    },
    B16: {
      code: "fosse-eng",
      initial_value: "B16",
      description: "",
      name_english: "",
      description_english: "",
      name: "Fosse-eng"
    },
    B15: {
      code: "fosseberg",
      initial_value: "B15",
      description: "",
      name_english: "",
      description_english: "",
      name: "Fosseberg"
    },
    E05: {
      code: "fossesprøytsone",
      initial_value: "E05",
      description:
        "Naturtypen utgjøres av de åpne kantsonene omkring fosser («fosse-eng»). Fossene må ha et så stort fall og en så høy vannføring at det dannes en sone med stabil fossesprøyt og fosserøyk omkring nedre del av fossen. Fossesprøytsonene opptrer ofte i kontakt med vierkratt, høgstaudeskog/eng, eller (overrislede) bergflater, og kan ha vegetasjons­messig store likheter med disse naturtypene. Sonen nærmest fossen er karakterisert av en spesiell mosevegetasjon på stein og berg. Denne inne­holder særlig fuktighetskrevende arter, som ellers kan være knyttet til bekker og bekkekanter som sjelden eller aldri tørker ut. ",
      name_english: "",
      description_english: "",
      name: "Fossesprøytsone"
    },
    G10: {
      code: "fuglegjødsletEngOgKnaus",
      initial_value: "G10",
      description: "",
      name_english: "",
      description_english: "",
      name: "Fuglegjødslet eng og knaus"
    },
    D09: {
      code: "fuktenger",
      initial_value: "D09",
      description: "",
      name_english: "",
      description_english: "",
      name: "Fuktenger"
    },
    F08: {
      code: "gammelBarskog",
      initial_value: "F08",
      description:
        "Mange arter er avhengig av de stabile forhold og de strukturene som oppstår når økosystemer blir gamle. Gammel skog som har vært lite påvirket av menneskelig aktivitet gjennom tidene kjennetegnes generelt ved å ha mye liggende og stående død ved og trær med store dimensjoner. Skogen er ofte fleraldret og flersjiktet. Strukturene i en gammelskog vil variere med vegetasjonstyper og suksesjonstadier. Til alle treslag er det knyttet arter som er spesialister på akkurat dette treslaget, og mange av de mer igjen knyttet til spesielle aldersfaser i treets liv. En skog med flere treslag, spredt på ulike aldre vil automatisk inneholde flere arter enn en ensaldret skog med ett treslag. Naturtypen vil også omfatte velutviklede fattige sumpskoger.",
      name_english: "",
      description_english: "",
      name: "Gammel barskog"
    },
    F07: {
      code: "gammelBorealLauvskog",
      initial_value: "F07",
      description: "",
      name_english: "",
      description_english: "",
      name: "Gammel boreal lauvskog"
    },
    F02: {
      code: "gammelEdellauvskog",
      initial_value: "F02",
      description: "",
      name_english: "",
      description_english: "",
      name: "Gammel edellauvskog"
    },
    F19: {
      code: "gammelFuruskog",
      initial_value: "F19",
      description: "",
      name_english: "",
      description_english: "",
      name: "Gammel furuskog"
    },
    F18: {
      code: "gammelGranskog",
      initial_value: "F18",
      description: "",
      name_english: "",
      description_english: "",
      name: "Gammel granskog"
    },
    F25: {
      code: "gammelLavlandsblandingsskog",
      initial_value: "F25",
      description: "",
      name_english: "",
      description_english: "",
      name: "Gammel lavlandsblandingsskog"
    },
    F14: {
      code: "gammelSump-OgKildeskog",
      initial_value: "F14",
      description: "",
      name_english: "",
      description_english: "",
      name: "Gammel sump- og kildeskog"
    },
    B05: {
      code: "grotte",
      initial_value: "B05",
      description:
        "Naturlige eller menneskeskapte uoppvarmede hulrom.  Frostfrie og uoppvarmede hulrom som holder stabil temperatur, og hvor vintertemperaturen i hele eller deler av hulrommet ikke går under frysepunktet. Oftest med høy luftfuktighet og/eller med vannansamlinger. ",
      name_english: "",
      description_english: "",
      name: "Grotte"
    },
    G01: {
      code: "grunneStrømmer",
      initial_value: "G01",
      description: "",
      name_english: "",
      description_english: "",
      name: "Grunne strømmer"
    },
    F05: {
      code: "gråor-Heggeskog",
      initial_value: "F05",
      description:
        "Utforminig F0502 Liskog/raviner er lagt til utformingen F0706 gammel gråorheggeskog under F07 gammel boreal lauvskog. Skog der gråor, dunbjørk, hegg, selje, svartor og svartvier er viktige treslag. Frodig og artsrik skog dominert av urter og høye gras. Rik fauna spesielt av virvelløse dyr og fugler. På fuktig, næringsrik jord i dalbunner langs elver (flommarksskog), i raviner, i leirområder og på rasmark i lier. Flommarksskogene er preget av slamavsetning og høyt grunnvann. Liskogene er ofte gjengroingsstadier fra åpen kulturmark.",
      name_english: "",
      description_english: "",
      name: "Gråor-heggeskog"
    },
    D05: {
      code: "hagemark",
      initial_value: "D05",
      description:
        "Hagemark eller havnehager er ugjødslet eller lite gjødslet beitemark med tre- og/eller busksjikt. Feltsjiktet blir utnyttet til beite. Trær og busker står derfor ikke så tett. Trær og busker i hagemark blir gjerne utnyttet bl.a. til ved. Trærne kan også styves (lauves) dvs. at topper og greiner blir kuttet av til husdyrfôr eller til garving, men denne bruken har i dag stort sett opphørt. (Se nærmere beskrivelse under Høstingsskog og Lauveng.) ",
      name_english: "",
      description_english: "",
      name: "Hagemark"
    },
    E16: {
      code: "hurtigstrømmendeElveløp",
      initial_value: "E16",
      description: "",
      name_english: "",
      description_english: "",
      name: "Hurtigstrømmende elveløp"
    },
    D18: {
      code: "høstingsskog",
      initial_value: "D18",
      description:
        "Bare et mindretall av forekomstene er registrert.   Høstingsskog er lauvskog der trærne ble høstet ved “styving” eller “stubbelauving”. Styvingstrær blir høstet ved at greiner blir kuttet med noen års mellom­rom til husdyrfôr (“lauving”, ”rising”) eller­ til produksjon av bast, reip eller bark til garving­ (for nærmere utdyping se ”Skjøtselsboka for kultur­landskap og gamle norske kulturmarker.) De vanligste styvingstrærne var ask, alm, lavlandsbjørk og selje, men også rogn, osp, svartor, lind og eik ble styvet.Ved stubbelauving blir flerstammete trær kuttet ved basis til fôr (eller høstet til emneved). Hassel, or og fjellbjørk ble gjerne høstet slik. Ofte utviklet man høstingsskog i brattlendt, steinete terreng og på grov ur der forholdene ikke egnet seg til slått eller beite. Noen steder ble imidlertid også feltsjiktet i høstingsskogen utnyttet.  Bruk av høstingsskog har nå stort sett opphørt og de fleste har grodd igjen til tett skog. På Vestlandet finnes imidlertid fortsatt rester av tidligere høstings­skoger med styvingstrær i bratte fjordlier og i sør- og sørvestvendte lier i dalene. Stubbelauvet høstingsskog er det lite igjen av. ",
      name_english: "",
      description_english: "",
      name: "Høstingsskog"
    },
    E11: {
      code: "ikkeForsuretRestområde",
      initial_value: "E11",
      description:
        "Naturtypen er bare interessant i (kraftig) forsurete områder der det foreligger tilbakegang og tap av forsuringsfølsomme arter over større arealer. Her opptrer de følsomme artene bare med små restforekomster («refugier») i ikke-forsurete lokaliteter, dvs. lokaliteter med et relativt høyt, naturlig kalkinnhold (kalsium-innhold > 2-3 mg Ca/l). Opptrer i fattige grunnfjellsområder gjerne der det er amfibolittganger, breksjesoner eller løsmasser under marin grense. Bare naturlig kalkrike lokaliteter inngår (dvs. kalkete lokaliteter kart­legges normalt ikke, men kan inkluderes der de er langtidskalket og fungerer som viktige refugier). ",
      name_english: "",
      description_english: "",
      name: "Ikke forsuret restområde"
    },
    A02: {
      code: "intaktHøgmyr",
      initial_value: "A02",
      description:
        "Intakt høgmyr og Terrengdekkende myr) er nå slått sammen og delt inn i to naturtyper (Intakt myr i ytre kyststrøk og Intakt lavlandsmyr i innlandet)",
      name_english: "",
      description_english: "",
      name: "Intakt høgmyr"
    },
    A01: {
      code: "intaktLavlandsmyr",
      initial_value: "A01",
      description: "",
      name_english: "",
      description_english: "",
      name: "Intakt lavlandsmyr"
    },
    A07: {
      code: "intaktLavlandsmyrIInnlandet",
      initial_value: "A07",
      description:
        "Utformingen A0701 er flyttet til naturtypen A10 Høgmyrer i innlandet Intakte myrtyper i lavlandet i Sør- og Midt-Norge, med unntak av kystområdene (oseaniske områder, kystmyr). Rikmyr, kilde og kildebekk (se egne fakta­ ark) kan inngå.",
      name_english: "",
      description_english: "",
      name: "Intakt lavlandsmyr i innlandet"
    },
    B09: {
      code: "isinnfrysingsmark",
      initial_value: "B09",
      description: "",
      name_english: "",
      description_english: "",
      name: "Isinnfrysingsmark"
    },
    B08: {
      code: "jordpyramide",
      initial_value: "B08",
      description: "",
      name_english: "",
      description_english: "",
      name: "Jordpyramide"
    },
    F16: {
      code: "kalkbarskog",
      initial_value: "F16",
      description: "",
      name_english: "",
      description_english: "",
      name: "Kalkbarskog"
    },
    F15: {
      code: "kalkedellauvskog",
      initial_value: "F15",
      description: "",
      name_english: "",
      description_english: "",
      name: "Kalkedellauvskog"
    },
    E21: {
      code: "kalkfattigOgKlarBekkEllerElv",
      initial_value: "E21",
      description: "",
      name_english: "",
      description_english: "",
      name: "Kalkfattig og klar bekk eller elv"
    },
    E19: {
      code: "kalkrikBekkOgLitenElv",
      initial_value: "E19",
      description: "",
      name_english: "",
      description_english: "",
      name: "Kalkrik bekk og liten elv"
    },
    D08: {
      code: "kalkrikeEnger",
      initial_value: "D08",
      description: "",
      name_english: "",
      description_english: "",
      name: "Kalkrike enger"
    },
    C01: {
      code: "kalkrikeOmråderIFjellet",
      initial_value: "C01",
      description:
        "Samlenaturtype for all kalkrik vegetasjon i fjellet. Kalkrik bergrunn gir et næringsrikt jordsmonn og stedvis frodig vegetasjon med et høyt antall urter, lav og moser. Rikmyrer og rikkilder over skoggrensa kan kartlegges separat dersom en ønsker det (se også myrkapitlet). Gamle beite- og slåtte­marker er også gjerne knyttet til næringsrike områder på kalkrik grunn.",
      name_english: "",
      description_english: "",
      name: "Kalkrike områder i fjellet"
    },
    E07: {
      code: "kalksjø",
      initial_value: "E07",
      description:
        "Små, (sterkt) kalkrike, næringsfattige innsjøer, gjerne med kalkutfellinger på vegetasjon og på bunnen (kalsium > 20 mg Ca/l). Karakterisert av kransalgevegetasjon (mest Chara spp.) som bygger opp kalkmergelbanker, noen ganger også vel­utviklet langskuddsvegetasjon (overgang mot «tjønnaks-sjøer»; se kulturlandskapssjøer). Videre karakterisert bl.a. av kalkavhengige, skallbærende snegler og muslinger, svamper, samt kalsifile insekter. Også en del mer eller mindre kalk­krevende dyreplanktonarter (eks. Daphniaspp.).",
      name_english: "",
      description_english: "",
      name: "Kalksjø"
    },
    F03: {
      code: "kalkskog",
      initial_value: "F03",
      description:
        "Utforminger som ikke er serpentinfuruskog eller kalkbjørkeskog er lagt til utforminger under F16 kalkbarskog Gjerne åpen skog med stor variasjon i treslag. Vanligst er furu, gran og dunbjørk. Stor variasjon i vegetasjons­typer fra ekstremt tørre til sesongfuktige typer. Artsrik kantvegetasjon. Best utviklet på varme lokaliteter med kalkrike bergarter, skjellsand eller kalkrik mineraljord og et grunt jordsmonn. Skogtype dominert av lågurter med mange sjeldne orkideer og marklevende sopp. Lite påvirket skog kan ha naturskogspreg, men mange er preget av tidligere beite. ",
      name_english: "",
      description_english: "",
      name: "Kalkskog"
    },
    F24: {
      code: "kalkskogMedBorealeLauvtrær",
      initial_value: "F24",
      description: "",
      name_english: "",
      description_english: "",
      name: "Kalkskog med boreale lauvtrær"
    },
    B02: {
      code: "kantkratt",
      initial_value: "B02",
      description:
        "Naturlig forekommende krattvegetasjon. Naturtype som omfatter skogkanter mot rasmarker, strender og andre åpne områder. Vegetasjonen preges av lys- og varmekrevende busker, gras og urter­som ikke er konkurransedyktige i sluttet skogvegetasjon. Krattvegetasjon kan være et resultat av gjen­groing av tidligere åpen kulturmark, men det presiseres at denne kartleggingsenheten ikke er tenkt å vektlegge gjengroingsfaser av skjøtselsbetingede naturtyper i kulturlandskapet. ",
      name_english: "",
      description_english: "",
      name: "Kantkratt"
    },
    A06: {
      code: "kilde",
      initial_value: "A06",
      description:
        "Naturtypen utgjøres av rike kilder (oppkommer/ grunnvannsframspring) og bekkestrekninger nedstrøms kilder, karakterisert av jevn vannføring (aldri­ uttørring), jevn vanntemperatur og høyere kalkinnhold enn omkringliggende naturtyper. Kildene­ opptrer ofte i kontaktsonen fastmark/myrkant, gjerne i tilknytning til kalkrike skogstyper og rikmyr. Selve kilden/kildekantener karakterisert av en spesiell mosevegetasjon dominert bl.a. av kildemosearter og tuffmoser.",
      name_english: "",
      description_english: "",
      name: "Kilde"
    },
    E03: {
      code: "kroksjøerFlomdamOgMeandrerendeElveparti",
      initial_value: "E03",
      description:
        "Flomdammer er små, grunne (< 5 m) vannforekomster på elvesletter som oversvømmes ved flom. Ofte med begrenset levetid. Kroksjøer er avsnørte elvebuer (meanderbuer). Flomdammene er ofte rester av gamle flomløp, oppdemte bekkemunninger o.l. Forekomstene er karakterisert av arter som finnes spredt til sjelden i selve elvestrengen, og dels arter som hører hjemme i små, grunne vannforekomster. Meandrerende elveparti er partier­ der elva slynger seg i store buer over en flat elveslette. Elva graver i ytterkant, og sedimenterer i innerkant av meanderbuen. ",
      name_english: "",
      description_english: "",
      name: "Kroksjøer flomdam og meandrerende elveparti"
    },
    F12: {
      code: "kystfuruskog",
      initial_value: "F12",
      description:
        "Kystfuruskogen har innslag av kystbundne karplanter, moser og lav, særlig i rikere skog. Deler av kystfuruskogene var tidligere lyngheier som nå er i ferd med å gro igjen. Stort innslag av einer­ og røsslyng er typisk, og kanskje en følge av kulturpåvirkning. Flere spesielle utforminger etter næring i jordsmonn, eksponering og geografi. De fuktigste utformingene er å betrakte som regnskogsmiljøer. ",
      name_english: "",
      description_english: "",
      name: "Kystfuruskog"
    },
    F11: {
      code: "kystgranskog",
      initial_value: "F11",
      description:
        "Boreal regnskog med gran som dominerende treslag.  Fuktig og kjølig granskog med nettverk av ren­nende vann og sig. Stort antall av lav- og mosearter. Frodige og artsrike forekomster av lav på trærne. I ytre strøk er skogen ofte iblandet bjørk, selje, rogn og gråor. ",
      name_english: "",
      description_english: "",
      name: "Kystgranskog"
    },
    D07: {
      code: "kystlynghei",
      initial_value: "D07",
      description:
        "Treløse, beiteskapte heisamfunn langs kysten med lyngarter, siv, gras og starr, vanligvis dominert av noen få plantearter. Røsslyng er et vesentlig innslag og dominerer ofte på tørrere deler, mens fuktigere deler kan være dominert av gras-, siv- og starr­arter. Den geografiske variasjonen er betydelig med store, lyngfattige fuktheier i Sør-­Rogaland, sørvendte tørrheier med purpurlyng lengst i vest og et større innslag av blokkebær og andre bærlyngarter på nordvendte lokaliteter, i høyden og nord for Stadt. Disse heiene danner gjerne mosaikk med myr, grasmark og strandsamfunn. ",
      name_english: "",
      description_english: "",
      name: "Kystlynghei"
    },
    A11: {
      code: "kystmyr",
      initial_value: "A11",
      description:
        "Utformingene A0801 og A0802 er flyttet til naturtypen A11 oseanisk nedbørsmyr Intakte myrtyper i kystområdene (oseaniske områder, mest O3-seksjonen, men og O2 (se fig. 5.4). Finnes mest i vegetasjonssonene boreonemoral-mellomboreal. Innen O2-seksjonen finnes terrengdekkende myr i nordboreal sone (f.eks. i Trøndelag­). Myrer i alpin sone er mindre aktuelle. ",
      name_english: "",
      description_english: "",
      name: "Kystmyr"
    },
    G11: {
      code: "kystnærGrusOgSteinmark",
      initial_value: "G11",
      description: "",
      name_english: "",
      description_english: "",
      name: "Kystnær grus og steinmark"
    },
    D17: {
      code: "lauveng",
      initial_value: "D17",
      description:
        "Lauveng er slåttemark med spredte lauvtrær. Trærne blir med jevne mellomrom styvet/høstet til fôr (dvs. “lauvet” om sommeren eller “riset” tidlig om våren) og har derfor små kroner. Denne driften gjør at styvingstrærne kan bli eldre enn andre trær. Også (hassel)busker som blir høstet (“stubbelauvet”) med jevne mellomrom kan inngå i lauvenga. Lauvenga er lite eller ikke gjødslet, men feltsjiktet er likevel gjerne frodig. På grunn av veksling mellom lys og skygge er artssammensetningen også variert. Langvarig hevd bidrar også til artsmangfold.  Styving har nå nesten opphørt som driftsform bortsett fra på enkelte gårder bl.a. på Vestlandet (eks. Sogn) og i Telemark. De fleste gjenværende lauvenger er derfor gjengrodd eller i ferd med å gro igjen.",
      name_english: "",
      description_english: "",
      name: "Lauveng"
    },
    B06: {
      code: "leirskredgrop",
      initial_value: "B06",
      description: "",
      name_english: "",
      description_english: "",
      name: "Leirskredgrop"
    },
    A10: {
      code: "låglandsmyrIInnlandet",
      initial_value: "A10",
      description: "",
      name_english: "",
      description_english: "",
      name: "Låglandsmyr i innlandet"
    },
    E20: {
      code: "middelsKalkrikBekkILåglandet",
      initial_value: "E20",
      description: "",
      name_english: "",
      description_english: "",
      name: "Middels kalkrik bekk i låglandet"
    },
    E15: {
      code: "middelsKalkrikInnsjø",
      initial_value: "E15",
      description: "",
      name_english: "",
      description_english: "",
      name: "Middels kalkrik innsjø"
    },
    E02: {
      code: "mudderbank",
      initial_value: "E02",
      description:
        "Åpne, beskyttede strandsoner og gruntvannsområder på finsubstrat (leire, mudder, silt, finsand). Ofte kulturpåvirket og avhengig av beite. Særlig knyttet til bakevjer, bukter og dammer langs stilleflytende elver, samt til deltaområder, men også ved grunne innsjøer. Karakterisert av mange små, ettårige, amfibiske (periodevis vannlevende) pusleplanter. Går innover på stranda gjerne over i fuktenger. ",
      name_english: "",
      description_english: "",
      name: "Mudderbank"
    },
    D04: {
      code: "naturbeitemark",
      initial_value: "D04",
      description:
        "Ikke tresatt beitemark med lang hevd som har vært lite/ikke gjødslet eller jordbearbeidet. Velhevdede naturbeitemarker som har blitt stadig sjeldnere. De kan være meget artsrike og mange planter, sopp og insekter er typiske for disse beitemarkene. ",
      name_english: "",
      description_english: "",
      name: "Naturbeitemark"
    },
    E10: {
      code: "naturligFisketommeInnsjøerOgTjern",
      initial_value: "E10",
      description:
        "Omfatter myrtjern samt mer eller mindre høyereliggende innsjøer som pga. spredningshindere eller uegnete forhold for reproduksjon er naturlig fisketomme, og hvor det heller ikke har vært satt ut fisk. Karakterisert av større arter av bunndyr og dyreplankton som ikke greier seg med fisk tilstede, inkludert enkelte reliktarter med hovedforekomster i høyereliggende innsjøer som aldri har hatt fiskepopulasjoner. ",
      name_english: "",
      description_english: "",
      name: "Naturlig fisketomme innsjøer og tjern"
    },
    B04: {
      code: "oseaniskeBerg",
      initial_value: "B04",
      description: "",
      name_english: "",
      description_english: "",
      name: "Oseaniske berg"
    },
    A04: {
      code: "palsmyr",
      initial_value: "A04",
      description:
        "Palsmyr er en type blandingsmyr med torv­hauger (palser) med en kjerne av torv og islinser som holder seg frosset gjennom hele sommeren. Palsmyr er således en type permafrost. Palsene kan være fra noen desimeter til 6-7 meter høye. De er for størstedelen nedbørsmyr, og de ligger som øyer i minerotrofe myrpartier",
      name_english: "",
      description_english: "",
      name: "Palsmyr"
    },
    B07: {
      code: "ravinedal",
      initial_value: "B07",
      description: "",
      name_english: "",
      description_english: "",
      name: "Ravinedal"
    },
    F20: {
      code: "regnskog",
      initial_value: "F20",
      description: "",
      name_english: "",
      description_english: "",
      name: "Regnskog"
    },
    F17: {
      code: "rikBarskog",
      initial_value: "F17",
      description: "",
      name_english: "",
      description_english: "",
      name: "Rik barskog"
    },
    B14: {
      code: "rikBerglendtMark",
      initial_value: "B14",
      description: "",
      name_english: "",
      description_english: "",
      name: "Rik berglendt mark"
    },
    F13: {
      code: "rikBlandingsskogILavlandet",
      initial_value: "F13",
      description:
        "Naturtypen opptrer i to vikarierende utforminger i boreonemoral og sørboreal sone, særlig på sørlige Østlandet. Den opptrer særlig i områder med «uryddig» topografi og variert berggrunn, på lokalklimatisk gunstige steder i terrenget som sørvendte lier, brattskråninger, sprekkedaler og bekkedaler. Den er derfor oftest naturlig fragmentert i mindre enheter. Jordsmonnet er for det meste ganske tørt og grunnlendt. Fellestrekk er stor småskalavariasjon i naturgrunnlaget, generell dominans av rike vegetasjonstyper, stor treslagsblanding med mye lauvtrær, og et utpreget heterogent og mosaikkartet skogbilde og vegetasjon. Naturtypen inkluderer elementer fra flere andre naturtyper, særlig «gammel barskog» (gran), «gammel lauvskog», «rik edellauvskog» og «gammel edellauvskog». Vegetasjon og skogstruktur opptrer i en så finskala og uryddig blanding at det er mest hensiktsmessig å beskrive dette som én samlet mosaikknaturtype.  Naturverdiene er knyttet til mange ulike egenskaper (bl.a. rike vegetasjonstyper, stor treslagsvariasjon, gamle lauvtrær, gamle edellauvtrær, død ved) som opptrer tett sammen i en variert mosaikk, noe som gjør dette til artsrike hotspots. Disse blandingsskogene har noen av de største ansamlingene av truete og sjeldne arter i Norden.",
      name_english: "",
      description_english: "",
      name: "Rik blandingsskog i lavlandet"
    },
    F04: {
      code: "rikBorealLauvskog",
      initial_value: "F04",
      description: "",
      name_english: "",
      description_english: "",
      name: "Rik boreal lauvskog"
    },
    F01: {
      code: "rikEdellauvskog",
      initial_value: "F01",
      description:
        "Skog av varmekjære lauvtrær som ask, alm, eik, hassel, lind, bøk, svartor og spisslønn. Artsrike og frodige skoger med krav til varmt sommerklima, ofte på veldrenert og næringsrik jord i områder med rike bergarter. Ofte i sørvendte lier i tilknytning til bergvegger med underliggende rasmark. Ofte preget av tidligere tradisjonelle bruksformer som styving (høsting av lauv) og beite, med betydning for artsinnhold og utforming. ",
      name_english: "",
      description_english: "",
      name: "Rik edellauvskog"
    },
    C04: {
      code: "rikeSnøleier",
      initial_value: "C04",
      description:
        "Utformingene C0101 rabbe og C0102 leside er flyttet til ny naturtype C03 rik fjellhei og tundra. Utforming C0103 Snøleie er flyttet til ny naturtype C04 Rike snøleier.",
      name_english: "",
      description_english: "",
      name: "Rike snøleier"
    },
    C03: {
      code: "rikFastmarkIFjellet",
      initial_value: "C03",
      description: "",
      name_english: "",
      description_english: "",
      name: "Rik fastmark i fjellet"
    },
    E08: {
      code: "rikKulturlandskapssjø",
      initial_value: "E08",
      description:
        "Omfatter innsjøer i kulturlandskapet, karakterisert av relativt kalk- og næringsrikt vann (mesotrofe til eutrofe innsjøer). Ofte betegnet som «naturlig næringsrike (eutrofe) innsjøer», selv om noe av næringsrikdommen som regel er et resultat av beliggenheten i (gamle) kulturlandskap. Kart­leggingsbehovet er særlig stort mht. lite eller moderat­ gjødselspåvirkete (mesotrofe – svakt eutrofe) innsjøer med intakt mangfold. Overgjødsleteinnsjøer med hyppige algeoppblomstringer bør også vurderes. ",
      name_english: "",
      description_english: "",
      name: "Rik kulturlandskapssjø"
    },
    A05: {
      code: "rikmyr",
      initial_value: "A05",
      description:
        "Jordvannsmyrer hovedsakelig på baserik berggrunn. Bunnsjiktet domineres av andre moseslekter enn torvmose, og minst én av de følgende artene inngår: myrstjernemose, rødmakkmose, stormakkmose. Feltsjiktet domineres ofte av grasvekster.   Spesielt i lavlandet er rike myrer i dag sjeldne. På middelsrik myr er jåblom, sveltull, breiull og de nevnte moseartene gode karakterarter. Eksempler på karakteristiske arter for ekstremrikmyr er brunskjene og sotstarr.",
      name_english: "",
      description_english: "",
      name: "Rikmyr"
    },
    F23: {
      code: "rikOlivinfuruskog",
      initial_value: "F23",
      description: "",
      name_english: "",
      description_english: "",
      name: "Rik olivinfuruskog"
    },
    F06: {
      code: "rikSumpskogKildeskogOgStrandskog",
      initial_value: "F06",
      description:
        "Næringsrike typer av lauvskog og kratt som vokser på sumpjord, gjerne tilknyttet forsenkninger i landskapet, raviner, rundt innsjøer, på elvesletter og langs bekker. Jordsmonnet har periodevis høy vannstand, spesielt på våren og forsommeren. Generelt dårlig drenering. Inneholder mange arter som krever stabile fuktighetsforhold.  Velutviklet fattig sumpskog kan kartlegges som gammel barskog eller gammel lauvskog.",
      name_english: "",
      description_english: "",
      name: "Rik sumpskog kildeskog og strandskog"
    },
    G09: {
      code: "riktStrandberg",
      initial_value: "G09",
      description:
        "Der berggrunnen består av baserike («kalkrike») bergarter er vegetasjonen mer artsrik enn tilsvarende på fattigere berggrunn. Strandbergene kan også påvirkes av skjellsand, særlig i berg­sprekker (“sjøsprøytsprekker”), og noen steder opptrer sesong­fuktige utforminger påvirket av kalkrikt sige­vann. Grunnet varierende eksposisjon og topografiske forhold, med ulik bølgepåvirkning, grad av humusdannelse og kulturpåvirkning, kan det være store variasjoner i plantedekket. Eksponerte odder, øyer og skjær er gjerne mer eller mindre helt nedvasket, med rikelig av fjærepytter, mens de beskyttede har et betydelig vegetasjonsdekke. Det er også store regionale forskjeller (se under utforminger). ",
      name_english: "",
      description_english: "",
      name: "Rikt strandberg"
    },
    E17: {
      code: "roligflytendeElveløp",
      initial_value: "E17",
      description: "",
      name_english: "",
      description_english: "",
      name: "Roligflytende elveløp"
    },
    G03: {
      code: "sanddyne",
      initial_value: "G03",
      description:
        "Sanddyner, eller flyvesandområder, kjennes først og fremst på forekomsten av fin sand som lett lar seg flytte av vinden, og det skapes dermed stadig nye formasjoner i landskapet. De klassiske «høydynene» er en sjelden naturtype i vårt land, stort sett avgrenset til områdene på Lista, Jæren og spredte forekomster i Nord-Norge, men mindre områder med flyvesand finnes mange steder langs kysten. Dynelandskapet er en variert og mosaikkpreget naturtype, med soneringer av tørre og artsfattige fordyner ytterst, dernest fuktigere, eroderte partier (såkalte dynetrau), til mer stabile, vegetasjonsdekkede enger og kratt innerst.   Pga. ekstreme livsbetingelser (ustabilt, mineralrikt substrat og rask drenering/uttørking) er plante- og dyrelivet ofte spesielt og områdene lette å avgrense. Større flyvesandområder og forekomster av spesielle og/eller sjeldne plantesamfunn bør prioriteres i kartleggingen.",
      name_english: "",
      description_english: "",
      name: "Sanddyne"
    },
    F22: {
      code: "sandfuruskog",
      initial_value: "F22",
      description: "",
      name_english: "",
      description_english: "",
      name: "Sandfuruskog"
    },
    F09: {
      code: "skogsbekkekløft",
      initial_value: "F09",
      description: "",
      name_english: "",
      description_english: "",
      name: "Skogsbekkekløft"
    },
    D15: {
      code: "skrotemark",
      initial_value: "D15",
      description:
        "Skrotemark er en samlebetegnelse på menneskeskapte naturtyper som i hovedsak oppstår i forbindelse med deponering av masser, samtindustri- og anleggsvirksomhet og lignende. Naturtypen er som regel forstyrrelsesbetinget, og inneholder gjerne innførte arter eller konkurransesvake arter som etablerer seg i ledige nisjer. ",
      name_english: "",
      description_english: "",
      name: "Skrotemark"
    },
    D01: {
      code: "slåttemark",
      initial_value: "D01",
      description:
        "Slåttemarker i langvarig hevd som har vært lite/ikke gjødslet eller jordbearbeidet. Slåttemark fantesbåde i innmark (slåtteenger) og utmark (utslåtter). De gamle, tradisjonelle slåttemarkene blir (til forskjell fra “moderne” slåtteeng) slått seint dvs. på ettersommeren (etter 10. juli). Høyet bakketørkes eller tørkes på hesjer før det fjernes. Slåttemarkene (særlig i innmark) har tradisjonelt vært etterbeitet på høsten, og noen beites også en periode på forsommeren. Tilbakegangen av naturtypen har vært svært sterk, og velhevdede slåttemarker er helt borte i mange distrikter. Både artsmangfold, identifikasjon og trusselsfaktorer har store likhetstrekk med naturbeitemarkene, men det er også viktige forskjeller som bl.a. beror på at: • dyr beiter selektivt, mens ljåen skjærer av alle plantene likt • det føres bort mer næringsstoffer med slått enn med beite • næringsstoffene er mer jevnt fordelte i slåttemark enn i beitemark der dyrene kan forårsake “omfordeling” næringsstoffene  • beitemarka påvirkes i større grad av tråkk. ",
      name_english: "",
      description_english: "",
      name: "Slåttemark"
    },
    D02: {
      code: "slåttemyr",
      initial_value: "D02",
      description:
        "Myrer med slåttebetinget eller beitepåvirket vegetasjon­ og preg.  Mange myrer ble tradisjonelt slått som en del av fôrberginga. Etter siste krig forsvant denne driftsformen raskt, men flere steder bærer likevel vegetasjonen preg av tidligere slått. Slåtten forandrer myrvegetasjonen på flere måter, bl.a.ved å: • redusere mengden busker og lyngplanter • fjerne biomasse og i neste omgang redusere mengden strø på marka • hindre tuedannelse • øke mengden gras, starr, siv og moser (men det blir mindre torvmoser) • berede for konkurransesvake fjellplanter også på skogsmyrene • øke mengden orkidéer  Bruken av våt myr til beite begrenses av myras svake bæreevne. Det var først og fremst kyr som beitet på myr. ",
      name_english: "",
      description_english: "",
      name: "Slåttemyr"
    },
    D11: {
      code: "småbiotoper",
      initial_value: "D11",
      description:
        "Små rester av ulike biotoper eller elementer i jordbrukslandskapet og selve dyrkingslandskapet. Småbiotoper er gjerne små artsrike «oaser»i et elers ensartet jordbrukslandskap som for eksempelåkerholmer, steinrøyser og bergknauser. Spesielt verdifulle forekomster må identifiseres på grunnlag av hvilke arter og elementer de inneholder, samt hvor ensartet det omkringliggende land­skapet er. Enkelte verdifulle småbiotoper behandles under­ andre naturtyper, bl.a. våtmark og kantkratt (rasmark/­berg). Åkerholmer, berg­knauser, ulike kantsoner m.v. har ofte tidligere vært slått og/ eller beitet­, men områdene har ikke blitt pløyd/dyrket opp fordi de var uegnet til det. ",
      name_english: "",
      description_english: "",
      name: "Småbiotoper"
    },
    G04: {
      code: "steinGrusOgSandstrand",
      initial_value: "G04",
      description: "",
      name_english: " ",
      description_english: "",
      name: "Stein grus og sandstrand"
    },
    D12: {
      code: "storeGamleTrær",
      initial_value: "D12",
      description:
        "Typen omfatter store og gamle frittstående lauvtrær, styvingstrær og/eller hule trær i kulturlandskapet. Slike trær er ikke en naturtype i egentlig forstand, men et kulturlandskapselement.   På grunn av at store trær har så stor betydning for andre organismer blir de likevel registrert som en naturtype. Særlig frittstående, gamle eiker og andre­ edellauvtrær i kulturlandskapet er viktige biotoper. ",
      name_english: "",
      description_english: "",
      name: "Store gamle trær"
    },
    G05: {
      code: "strandengOgStrandsump",
      initial_value: "G05",
      description:
        "Strandenger opptrer på beskyttede, slake løsmassestrender (leire, silt, mudder) med engvegetasjon av salttolerante grasarter og urter, med regelmessige oversvømminger av sjøvann. Store strandengkompleks forekommer gjerne på innsiden av større, grunne bukter og brakkvannspoller. Er også ofte påvirket av ferskvannssig fra lands­iden. Mange strandenger ble tidligere beitet eller slått. Ikke-hevdete strandenger er gjerne dominert av høyvokste grasarter, strandkvann m. fl., mens kortvokste, åpne utforminger opptrer der det er beitet eller der det er grunnlendt skjellsandsubstrat. Strand­sumper kan ligge lenger ut enn strandenga eller inne i brakkvannsviker og domineres som oftest av bestander av enkeltarter. Frodige, høyvokste strandsumper av f.eks. havsivaks eller havstarr opptrer der det er dypere sedimenter av leire og organisk mudder. Store takrørsumper opptrer særlig ved bekkeutløp/brakkvannsområder og kan også føres til denne naturtypen.",
      name_english: "",
      description_english: "",
      name: "Strandeng og strandsump"
    },
    E14: {
      code: "sværtKalkfattigInnsjø",
      initial_value: "E14",
      description: "",
      name_english: "",
      description_english: "",
      name: "Svært kalkfattig innsjø"
    },
    B01: {
      code: "sørvendtBergOgRasmark",
      initial_value: "B01",
      description:
        "Sørvendte berg og bergvegger, og rasmarker nedenfor skoggrensen. Stein- og blokkrike skråninger (ur, rasmark) dannet ved forvitring og utrasing under bratte bergvegger og hamrer. Vegetasjonen kan være rik i rasmarker, på knauser og bergflater med lettforvitrende, kalkholdige bergarter. Snøskred kan være en viktig faktor når det gjelder å hindre at områdene gror igjen med busker og trær.   Nord- og østvendte rasmarker er oftere bevokst med barskog, som på grunn av vanskelige driftsforhold kan ha fine utforminger av gammelskog. Denne naturtypen føres opp under hovednaturtypen skog. ",
      name_english: "",
      description_english: "",
      name: "Sørvendt berg og rasmark"
    },
    D24: {
      code: "tresattKulturmark",
      initial_value: "D24",
      description: "Erstatter D17 Lauveng og D05 Hagemark",
      name_english: "",
      description_english: "",
      name: "Tresatt kulturmark"
    },
    B03: {
      code: "ultramafiskOgKis-rikMark",
      initial_value: "B03",
      description:
        "Både ultrabasiske bergarter (olivin, serpentin) og tungmetallrike berg kjennes ofte lett igjen i felt på grunn av sin brune til rødbrune farge. Bergartene er giftige for mange planter og inneholder høye konsentrasjoner av bl.a. jern, magnesium, kobber, krom, molybden og nikkel. Det er typisk at man har en del interessante karplanter på ultrabasisk grunn, mens tungmetallrik grunn gjerne har noen interessante moser, i mindre grad karplanter.",
      name_english: "",
      description_english: "",
      name: "Ultramafisk og kis-rik mark"
    },
    G02: {
      code: "undervannseng",
      initial_value: "G02",
      description: "",
      name_english: "",
      description_english: "",
      name: "Undervannseng"
    },
    B10: {
      code: "urOgRasmark",
      initial_value: "B10",
      description: "",
      name_english: "",
      description_english: "",
      name: "Ur og rasmark"
    },
    E12: {
      code: "vannkantsamfunn",
      initial_value: "E12",
      description: "",
      name_english: "",
      description_english: "",
      name: "Vannkantsamfunn"
    },
    E06: {
      code: "viktigBekkedrag",
      initial_value: "E06",
      description:
        "Små vassdrag i kulturlandskapet, kalkrike bekker og andre viktige bekkedrag. Bekkene er blodårer i landskapet, særlig i intensivt kulturlandskap og i fattige skogsmiljøer. Verdien ligger både i vannet og i kantsonen langs bekken. Kartleggingen fokuserer på spesielt verdifulle partier og bekker med landskapsøkologisk betydning. ",
      name_english: "",
      description_english: "",
      name: "Viktig bekkedrag"
    },
    A09: {
      code: "våtmarksmassiv",
      initial_value: "A09 ",
      description: "",
      name_english: "",
      description_english: "",
      name: "Våtmarksmassiv"
    },
    E04: {
      code: "åpenFlommark",
      initial_value: "E04",
      description: "",
      name_english: "",
      description_english: "",
      name: "Åpen flommark"
    },
    D19: {
      code: "åpenGrunnlendtKalkmark",
      initial_value: "D19",
      description: "",
      name_english: "",
      description_english: "",
      name: "Åpen grunnlendt kalkmark"
    },
    B13: {
      code: "åpenKalkmark",
      initial_value: "B13",
      description: "",
      name_english: "",
      description_english: "",
      name: "Åpen kalkmark"
    },
    D20: {
      code: "åpenKalkmarkIOslofeltet",
      initial_value: "D20",
      description: "",
      name_english: "",
      description_english: "",
      name: "Åpen kalkmark i oslofeltet"
    }
  },
  NMA: {
    I15: {
      code: "andreViktigeMarineNaturtyper",
      initial_value: "I15",
      description:
        'C - Områder som vurderes som viktige på lokalt nivå marine naturtyper Marine områder av betydning for kommunen Tidligere stavemåte; "Andre viktige forekomster", en forekomst overført til BN',
      name_english: "",
      description_english: "",
      name: "Andre viktige marine naturtyper"
    },
    I08: {
      code: "bløtbunnsområderIStrandsonen",
      initial_value: "I08",
      description:
        " A - Større strandflater (> 500 000 m2) som er næringsområde for bestander av overvintrende og trekkende vadefugler. B - Større strandflater (> 200 000 m2) som er næringsområde for stedegne fugler (vadefugler, andefugler) og fisk (kutlinger, flyndrer). ",
      name_english: "",
      description_english: "",
      name: "Bløtbunnsområder i strandsonen"
    },
    I03: {
      code: "fjorderMedNaturligLavtOksygeninnholdIBunnvannet",
      initial_value: "I03",
      description:
        "A - Fjordområder med permanent naturlig lavt oksygeninnhold i bunnvann (<2 ml/l) B - Fjorder der bunnvannet tidvis har naturlig lavt oksygeninnhold",
      name_english: "",
      description_english: "",
      name: "Fjorder med naturlig lavt oksygeninnhold i bunnvannet"
    },
    I06: {
      code: "litoralbasseng",
      initial_value: "I06",
      description:
        'A – Store, urørte litoralbasseng (>10 m2). Feil stavemåte; "Littoralbasseng" brukt tidligere',
      name_english: "",
      description_english: "",
      name: "Litoralbasseng"
    },
    I10: {
      code: "løstliggendeKalkalger",
      initial_value: "I10",
      description:
        'A – Store forekomster av løstliggende kalkalger (mergelbunner). Alle forekomster av ”ekte” mergelarter (sjeldne). B– enkeltfunn/mindre forekomster av løstliggende kalkalger Tidligere stavemåte; "Kalkalgeforekomster"',
      name_english: "",
      description_english: "",
      name: "Løstliggende kalkalger"
    },
    I05: {
      code: "poller",
      initial_value: "I05",
      description:
        "A - Poller som er lite påvirket eller upåvirket av menneskelig aktivitet, som er større enn ~200 000 m2 og/eller har spesielle arter. B – Andre poller som er lite påvirket eller upåvirket av menneskelig aktivitet. Alle G08-utforminger flyttet hit (10.01.2020)",
      name_english: "",
      description_english: "",
      name: "Poller"
    },
    I12: {
      code: "skjellsandforekomster",
      initial_value: "I12",
      description:
        'A - Større sammenhengende forekomster (> 100 000 m2) av ren skjellsand på grunt vann ned til ca. 10 m dyp, ofte med spredt bevoksning av tare B - Større forekomster av ren skjellsand (> 100 000 m2). I Skagerrak regnes alle forekomster større enn ca. 20 000 m2 som viktige. Tidligere stavemåte; "Skjellsand"',
      name_english: "",
      description_english: "",
      name: "Skjellsandforekomster"
    },
    I04: {
      code: "spesieltDypeFjordområder",
      initial_value: "I04",
      description:
        "A - Fjordområder med dyp > 700 m B - Fjordområder med dyp i intervallet 500-700 m",
      name_english: "",
      description_english: "",
      name: "Spesielt dype fjordområder"
    },
    I02: {
      code: "sterkeTidevannsstrømmer",
      initial_value: "I02",
      description:
        "A - De sterkeste strømmene, dvs strømhastighet over 10 knop eller lengden på området er >500m. B - Alle strømmer over ca. 5 knop Alle G01 utforminger overført hit (10.01.2020)",
      name_english: "",
      description_english: "",
      name: "Sterke tidevannsstrømmer"
    },
    I14: {
      code: "størreKamskjellforekomster",
      initial_value: "I14",
      description:
        "A - Store områder i arealskala 100 km2, dominert av sandbunnhabitater forekomster hvor bestander med stort kamskjell forekommer i høye tettheter og med bred alderssammensetning. Store arealer (10-50 km2), med sand-, stein- og grusbunn hvor bestander med haneskjell forekommer i høye tettheter og med bred alderssammensetning. Fjordlokaliteter hvor relikte haneskjell i store tettheter forekommer. B - Områder i arealskala 10-50 km2, dominert av sandbunn hvor bestander med stort kamskjell forekommer i høye tettheter og med bred alderssammensetning. Områder i arealskala 1 km2, med sand-, stein og grusbunn hvor bestander med haneskjell forekommer i høye tettheter og med bred alderssammensetning.",
      name_english: "",
      description_english: "",
      name: "Større kamskjellforekomster"
    },
    I01: {
      code: "størreTareskogforekomster",
      initial_value: "I01",
      description:
        "A – Lokaliteter med store, intakte tareskogområder (>500 000 m2). I Skagerrak regnes alle større tareskogsområder som svært viktige selv om utbredelsen er mindre enn 100 000 m2. B – Mindre områder med tareskog (~100 000 m2). Tareskog i nedbeita områder.",
      name_english: "",
      description_english: "",
      name: "Større tareskogforekomster"
    },
    I13: {
      code: "østersforekomster",
      initial_value: "I13",
      description:
        "A - Poller og terskelfjorder med god forekomst (0,5 - 4 ind/m2) av østers med stor aldersspredning og tydelig gjentatt rekruttering. Forekomst av gamle (>12 cm skallbredde) levende individer. Gjelder økoregionene Skagerrak og Nordsjøen (til 62°N) B - Økoregionene Skagerrak og Nordsjøen: Større områder (>1000 m2) med god forekomst (0,5 - 4 ind/m2) av østers med flere årsklasser. Østersbanker (>10 ind/m2) i områder større enn 1000 m2. Poller eller fjorder som gir hyppig gytesuksess under nåværende klimatiske forhold.  Økoregion Norskehavet (62-70°N): Poller, bukter og fjorder med forekomst av levende østers av flere årsklasser.",
      name_english: "",
      description_english: "",
      name: "Østersforekomster"
    },
    I11: {
      code: "ålegrasengerOgAndreUndervannsenger",
      initial_value: "I11",
      description:
        'A – Større upåvirkede komplekser av undervannsenger (> 100.000 m2) og alle forekomster av akutt truete utforminger som Dvergålegras, Havfrugras og Kortskuddplante-under-vannseng/forstrand-utforminger. B - Ålegrasenger nær kjente gyteplasser samt mindre undervannsenger ( < 100.000 m2). Alle G02 utforminger er overført hit (10.01.2020) Tidligere stavemåte; "Ålegrassamfunn"',
      name_english: "",
      description_english: "",
      name: "Ålegrasenger og andre undervannsenger"
    }
  },
  MAG: {
    OA: { code: "Innsjø oppdemt til andre formål" },
    OK: { code: "Innsjø oppdemt til kraftproduksjon" },
    RA: { code: "Reguleringsmagasin til andre formål" },
    RK: { code: "Reguleringsmagasin til kraftproduksjon" }
  },
  NIN: {
    "1": { code: "Svært høy kvalitet" },
    "2": { code: "Høy kvalitet" },
    "3": { code: "Moderat kvalitet" },
    "4": { code: "Lav kvalitet" },
    "5": { code: "Svært lav kvalitet" },
    "9": { code: "Kvalitet ikke kartlagt" }
  }
};

function getTextAreaReport(reportCode, resultCode, field) {
  const report = reports[reportCode];
  if (!report) return "";
  const object = report[resultCode];
  if (!object) return "";
  return object[field] || "";
}

export { getTextAreaReport };
